import $ from 'jquery';
import Foundation from './3rd/_zf.js';
//import { hdConfig } from './components/config.js';

import './components/global.js';
import './components/lighthouse.js';
import './components/back-to-top.js';
import './components/script-loader.js';
import { initMenu } from './components/menu.js';
import { initSocialShare } from './components/social-share.js';
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from '@fancyapps/ui';
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import '../sass/3rd/_index.scss';
//import 'simplebar/dist/simplebar.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initMenu('nav.nav', '.main-nav');
    initSocialShare('[data-social-share]', { intents: [ 'facebook', 'x', 'print', 'send-email', 'copy-link', 'web-share' ] });
});

Fancybox.bind('.fcy-popup, .fcy-video, .banner-video a', {});
Fancybox.bind('.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]', {
    groupAll: true, // Group all items
});

jQuery(function ($) {
  let header = $('#bottom-header');
  let headerHeight = header.outerHeight();

  $(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > headerHeight + 100) {
      header.addClass('w-sticky');
    } else {
      header.removeClass('w-sticky');
    }
  });
});

jQuery(function ($) {
    /** */
    const wpg__image = $('.wpg__image');
    wpg__image.find('a').on('click', function (e) {
        e.preventDefault();
        $(this).next('.image-popup').trigger('click');
    });

    /** */
    const wpg__thumb = $('.wpg__thumb');
    wpg__thumb.find('a').on('click', function (e) {
        e.preventDefault();
    });
});

jQuery(document).ready(function () {
	jQuery(".term-description-custom .desc").each(function () {
		if (jQuery(this).height() > 300) {
			jQuery(this).after('<a href="#" class="btn_show btn-main bg-white">Xem thêm</a>');
			jQuery(this).attr("data-height", jQuery(this).height() + "px");
			jQuery(this).css({
				height: '300',
			});
		}
	});
	jQuery(".btn_show").click(function(e){
		e.preventDefault();
		var this_content = jQuery(this).closest(".term-description-custom").find(".desc");
		jQuery(this).closest(".term-description-custom").find(".mask").remove();
		jQuery(this_content).animate({
			height	: 	jQuery(this_content).attr("data-height"),
		},500);
		jQuery(this).remove();
  });
  jQuery("#inside-header .search-mb .btn-search").click(function (e) {
    e.preventDefault();
    jQuery("#inside-header .search-mb .main-search").toggleClass("active");
  });
});

$(document).ready(function(){
  function animateCounter($el, target) {
    $({ countNum: 0 }).animate(
      { countNum: target },
      {
        duration: 2000,
        easing: 'swing',
        step: function() {
          $el.text(Math.floor(this.countNum).toLocaleString("de-DE"));
        },
        complete: function() {
          $el.text(this.countNum.toLocaleString("de-DE"));
        }
      }
    );
  }
  function startCounters() {
    $('.counter').each(function(){
      var $this = $(this);
      var target = parseInt($this.data('target'));
      if(!$this.hasClass('counted') && $(window).scrollTop() + $(window).height() > $this.offset().top){
        animateCounter($this, target);
        $this.addClass('counted');
      }
    });
  }
  $(window).on('scroll', startCounters);
  startCounters();
});